import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

export const fetchOrders = createAsyncThunk(
  "orders/fetch",
  async ({ page = 0, limit = 20, append = false } = {}) => {
    const res = await api.get(`/buyer/orders?page=${page}&limit=${limit}`);
    return {
      items: res.data.orders || [],
      total: res.data.total || 0,
      page: res.data.page || 0,
      limit: res.data.limit || limit,
      hasMore: !!res.data.hasMore,
      append,
    };
  }
);

export const createOrder = createAsyncThunk(
  "orders/create",
  async (orderData) => {
    const res = await api.post("/buyer/orders", orderData);
    return res.data.order;
  }
);

const ordersSlice = createSlice({
  name: "orders",
  initialState: { items: [], loading: false, error: null, total: 0, page: 0, limit: 20, hasMore: false },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.loading = false;
        const { items, total, page, limit, hasMore, append } = action.payload;
        state.total = total;
        state.page = page;
        state.limit = limit;
        state.hasMore = hasMore;
        state.items = append ? [...state.items, ...items] : items;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Error fetching orders";
      })
      .addCase(createOrder.fulfilled, (state, action) => {
        state.items.unshift(action.payload);
      });
  },
});

export default ordersSlice.reducer;
